import { gql } from "@apollo/client";

export const getSkillRatingDetails = gql`
  query getSkillRatingDetails($input: SRSCheckinDetailsInput) {
    getSRSCheckinDetails(input: $input) {
      ratees {
        firstName
        lastName
        profileImage {
          fileName
        }
        userid
      }
      totalRaters
      skills {
        skillName
        averageRateeScore
        ratedByCount
      }
      ratingResponse {
        groupByQuestionsComments {
          comment
          commentedDate
          raterId
          rater {
            firstName
            lastName
            profileImage {
              url
              fileName
            }
          }
        }
      }
      enhancedAnalytics {
        continue {
          feedback
        }
        start {
          feedback
        }
        stop {
          feedback
        }
      }
    }
  }
`;

export const getSRSCheckinDetails = gql`
  query getSRSCheckinDetails($input: SRSCheckinDetailsInput) {
    getSRSCheckinDetails(input: $input) {
      skills {
        skillName
        averageRateeScore
        ratedByCount
      }
      enhancedAnalytics {
        continue {
          feedback
        }
        start {
          feedback
        }
        stop {
          feedback
        }
      }
      ratingResponse {
        groupByQuestionsComments {
          comment
          commentedDate
          rater {
            firstName
            lastName
            id
          }
        }
        groupByQuestions {
          question
          totalUsers
          completedUsers
          questionResponse {
            date
            response
            rater {
              firstName
              lastName
              profileImage {
                fileName
              }
              id
            }
          }
          userResponsePieChart {
            responseStatistics {
              color
              count
              percentage
              text
              users {
                id
                firstName
                lastName
                profileImage {
                  bucket
                  key
                  region
                  url
                  uploadUrl
                  fileName
                  isNew
                  base64Data
                }
              }
            }
          }
        }
        groupByRaters {
          score
          status
          comments {
            comment
            raterId
            rater {
              id
              firstName
              lastName
              profileImage {
                fileName
              }
            }
          }
          questionResponse {
            date
            question
            response
          }
          rater {
            id
            firstName
            lastName
            profileImage {
              fileName
            }
          }
        }
      }
    }
  }
`;

export const targetLevelSkillScore = gql`
  query getSRSCheckinDetails($input: SRSCheckinDetailsInput) {
    getSRSCheckinDetails(input: $input) {
      frequencies {
        startDate
        endDate
        checkinId
        checkinName
        sequenceNo
      }
      totalRaters
      skills {
        skillName
        averageRateeScore
        ratedByCount
      }
      enhancedAnalytics {
        continue {
          feedback
        }
        start {
          feedback
        }
        stop {
          feedback
        }
      }
      ratingResponse {
        groupByQuestionsComments {
          comment
          commentedDate
          rater {
            firstName
            lastName
            id
          }
        }
        groupByQuestions {
          question
          questionResponse {
            date
            response
            rater {
              id
              firstName
              lastName
            }
          }
          userResponsePieChart {
            responseStatistics {
              color
              count
              percentage
              text
            }
          }
        }
        groupByRaters {
          score
          comments {
            comment
            raterId
          }
          questionResponse {
            date
            question
            response
          }
          rater {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
